import { Approval } from 'models/approval';
import GlobalDataCache from 'models/globalDataCache/globalDataCache';
import { mapFromTask, mapFromTasksArray } from './taskMapping';
import TaskDTO from 'models/dto/tasks/taskDTO';
import ApprovalResolve, { ApprovalSource } from 'models/approvalResolve';
import ApprovalResolveDTO from 'models/dto/approvalResolveDTO';

export function mapFromApprovals(approvalDTOs: TaskDTO[] | undefined, cache: GlobalDataCache): Approval[] {
  if (!approvalDTOs) return [];

  const output = approvalDTOs.map((item) => {
    return mapFromApproval(item, cache);
  });

  return output;
}

export function mapFromApproval(approvalDTO: TaskDTO, cache: GlobalDataCache): Approval {
  const output = new Approval();

  output.mainTask = mapFromTask(approvalDTO, cache);
  output.approvalTasks = mapFromTasksArray(approvalDTO.instances, cache);

  return output;
}

export function mapFromApprovalResolve(dto: ApprovalResolveDTO): ApprovalResolve {
  const output = new ApprovalResolve();

  output.linkId = dto.linkId;
  output.userIds = dto.userIds ?? [];
  output.templateId = dto.templateId;
  output.source = (dto.source as ApprovalSource) ?? ApprovalSource.None;
  output.conceptTaskId = dto.conceptTaskId;
  output.hasWorkflowTemplate = dto.hasWorkflowTemplate === true;

  return output;
}
